import { RadioButton } from 'lego-on-react';
import React, { useState } from 'react';

import i18n from '@yandex-int/i18n';
import * as keyset from 'i18n/Monitoring';
import block from 'propmods';

import { LoadingDataReducerStateType } from '../../reducers/loadingData';
import { MonitoringPageBarChart } from '../MonitoringPageBarChart/MonitoringPageBarChart';

import './MonitoringPageBarChartErrorSwitch.scss';

const t = i18n(keyset);
const b = block('MonitoringPageBarChartErrorSwitch');

interface Props {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    data: any[];
    labels: string[];
    dataLoadingState: LoadingDataReducerStateType;
    yAxisLabel?: string;
    displaySwitch?: boolean;
}

export const MonitoringPageBarChartErrorSwitch: React.FC<Props> = (props) => {
    const [type, setType] = useState('abs');

    const labels = props.labels.filter((label) => label !== 'total');

    const newData =
        type === 'abs'
            ? props.data
            : props.data.map((bar) => {
                  const newBar = { ...bar, total: undefined };

                  labels.forEach((label) => {
                      const total = bar.total;

                      if (total === 0) {
                          newBar[label] = 0;
                      } else {
                          newBar[label] = ((bar[label] / total) * 100 || 0).toFixed(2);
                      }
                  });

                  return newBar;
              });

    return (
        <div {...b()}>
            {props.displaySwitch && (
                <div {...b('switch')}>
                    <span {...b('switch-label')}>{t('chart-switch')}</span>
                    <RadioButton
                        disabled={props.dataLoadingState === 'loading'}
                        size="s"
                        theme="normal"
                        value={type}
                        onChange={(e) => setType(e.target.value)}
                    >
                        <RadioButton.Radio value={'abs'}>{t('chart-switch-num')}</RadioButton.Radio>
                        <RadioButton.Radio value={'perc'}>{t('chart-switch-rate')}</RadioButton.Radio>
                    </RadioButton>
                </div>
            )}
            <MonitoringPageBarChart {...props} data={newData} labels={labels} />
        </div>
    );
};
